import { render, staticRenderFns } from "./NotifyDialog.vue?vue&type=template&id=dd7e2b82"
import script from "./NotifyDialog.vue?vue&type=script&lang=js"
export * from "./NotifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports